module.exports = __webpack_public_path__ + "static/media/Acrilico (21).dd91613b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (21).jpg
// module id = 289
// module chunks = 0